import { env } from "@/config/env";

const phpBaseUrl = () => env.VITE_PHP_URL.replace(/\/$/, "");

async function postToPhp<T>(path: string, body: unknown): Promise<T> {
  //TODO transfer this service to Node
  const response = await fetch(`${phpBaseUrl()}${path}`, {
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
    method: "POST",
  });

  if (!response.ok) {
    throw new Error(`Request to ${path} failed (${response.status})`);
  }

  return response.json();
}

export function checkBankBalance(
  paymentMethodId: string,
  amountCents: number,
): Promise<{ sufficient: boolean }> {
  return postToPhp("/api/stripe/check-bank-balance", {
    amount: amountCents,
    payment_method_id: paymentMethodId,
  });
}

export function finalizeAchCheckout(paymentIntentId: string): Promise<unknown> {
  return postToPhp("/api/stripe/finalize-ach-checkout", {
    payment_intent_id: paymentIntentId,
  });
}
